import {dispatchSnackbar} from "src/v2/components/SnackBar/snackbar-bus"

export const parseClipboardCells = text => {
    const rows = []
    let row = []
    let value = ""
    let quoted = false
    let closed = false
    let rowStarted = false

    for (let index = 0; index < text.length; index++) {
        const character = text[index]
        if (quoted) {
            if (character === '"') {
                if (text[index + 1] === '"') {
                    value += '"'
                    index++
                } else {
                    quoted = false
                    closed = true
                }
            } else {
                value += character
            }
        } else if (character === "\t") {
            row.push(value)
            value = ""
            closed = false
            rowStarted = true
        } else if (character === "\n" || character === "\r") {
            if (rowStarted) rows.push([...row, value])
            row = []
            value = ""
            closed = false
            rowStarted = false
            if (character === "\r" && text[index + 1] === "\n") index++
        } else {
            if (closed) throw new Error("Texto tabulado inválido: conteúdo após o fechamento das aspas.")
            rowStarted = true
            if (character === '"' && value === "") {
                quoted = true
            } else {
                value += character
            }
        }
    }

    if (quoted) throw new Error("Texto tabulado inválido: campo entre aspas não encerrado.")
    if (rowStarted) rows.push([...row, value])
    return rows
}

export const removeTableHeader = (cells, keys, labels = keys) => {
    const first = cells[0]?.map(value => value.trim().toLocaleLowerCase("pt-BR"))
    const matches = expected => first?.length === expected.length &&
        expected.every((value, index) => first[index] === value.trim().toLocaleLowerCase("pt-BR"))
    if (!matches(keys) && !matches(labels)) {
        throw new Error("Cabeçalho inválido. Copie a tabela com cabeçalho e mantenha a ordem das colunas.")
    }
    const rows = cells.slice(1)
    if (!rows.some(row => row.some(value => value.trim()))) {
        throw new Error("A planilha não contém linhas de dados para colar.")
    }
    return rows
}

const escapeClipboardValue = value => {
    const text = String(value ?? "")
    return /[\t\r\n"]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

export const copyTableToClipboard = async (rows, fields, formatValue = (_, value) => value) => {
    if (!rows?.length) return

    try {
        const lines = [
            fields.map(escapeClipboardValue).join("\t"),
            ...rows.map(row => fields.map(field => escapeClipboardValue(formatValue(field, row[field]))).join("\t")),
        ]
        await navigator.clipboard.writeText(lines.join("\n"))
        dispatchSnackbar("Conteúdo copiado para a área de transferência.", "success")
    } catch (error) {
        dispatchSnackbar(error.message || "Não foi possível copiar os dados.", "error")
    }
}
